// extracted by mini-css-extract-plugin
export default {"container":"loader_container__V-Ndv","water":"loader_water__PfzuH","wave":"loader_wave__Vg5EW"};